const ajaxMorePost = ( $ ) => {
	const loadMoreButton = $( '.load-more-ajax' );
	const categoryFilter = $( '.selectric.category' );
	const statusFilter = $( '.selectric.status-filter' );
	const newsCategoryFilter = $( '.selectric.new-category' );
	const newsTagFilter = $( '.selectric.news-tag' );
	const areaOfFocusFilter = $( '.selectric.area-of-focus' );
	const typeOfOrganizationFilter = $( '.selectric.type-of-organization' );
	const searchFilter = $( 'button.icon-search' );
	const resetSearch = $( 'button.reset-search' );
	const searchFilterInput = $( '#search-filter' );
	const MIN_SEARCH_LENGTH = 3;
	const SEARCH_DEBOUNCE_DELAY = 400;
	let searchDebounceTimer = null;

	const getSearchInputValue = ( input ) =>
		input && input.length ? ( input.val() || '' ).trim() : '';

	const normalizeSearchValue = ( value ) => {
		const trimmed = ( value || '' ).trim();
		return trimmed.length >= MIN_SEARCH_LENGTH ? trimmed : '';
	};

	const getSearchValue = ( input ) =>
		normalizeSearchValue( getSearchInputValue( input ) );

	const getScope = ( element ) => {
		const $element = $( element );
		const $scope = $element.closest( '.cards-content, .section-news' );
		if ( $scope.length ) {
			return $scope;
		}

		const $section = $element.closest( 'section' );
		if ( $section.length ) {
			return $section;
		}

		return $element.parent();
	};

	const getScopeLoadMoreButtons = ( element ) => {
		const $scope = getScope( element );
		const $buttons = $scope.find( '.load-more-ajax' );
		return $buttons.length
			? $buttons
			: $( element ).closest( '.load-more-ajax' );
	};

	// Ajax request to load more posts and handle filters.
	if ( loadMoreButton.length ) {
		loadMoreButton.map( function ( i, el ) {
			hideLoadMoreButton(
				$( el ).data( 'max_page' ),
				$( el ).data( 'current_page' ),
				el
			);
		} );

		loadMoreButton.on( 'click', function ( e ) {
			e.preventDefault();

			const $button = $( this );
			const $scope = getScope( $button );
			const $categoryFilter = $scope.find( '.selectric.category' );
			const $statusFilter = $scope.find( '.selectric.status-filter' );
			const $newsCategoryFilter = $scope.find(
				'.selectric.new-category'
			);
			const $newsTagFilter = $scope.find( '.selectric.news-tag' );
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			const $searchFilterInput = $scope.find( '#search-filter' );

			let taxName = $categoryFilter.data( 'tax_name' ) || '';
			let taxTerm = $categoryFilter.val() || '';

			let secondTaxName = $statusFilter.data( 'tax_name' ) || '';
			let secondTaxTerm = $statusFilter.val() || '';

			// Fallback to data attributes on the button if no filters are present
			if ( ! taxName ) {
				taxName = $button.data( 'tax_name' ) || '';
			}
			if ( ! taxTerm ) {
				taxTerm = $button.data( 'tax_term' ) || '';
			}
			if ( ! secondTaxName ) {
				secondTaxName = $button.data( 'second_tax_name' ) || '';
			}
			if ( ! secondTaxTerm ) {
				secondTaxTerm = $button.data( 'second_tax_term' ) || '';
			}

			if ( $newsCategoryFilter.length ) {
				taxName = $newsCategoryFilter.data( 'tax_name' ) || '';
				taxTerm = $newsCategoryFilter.val() || '';
			}

			if ( $newsTagFilter.length ) {
				secondTaxName = $newsTagFilter.data( 'tax_name' ) || '';
				secondTaxTerm = $newsTagFilter.val() || '';
			}

			let postNotIn = $button.data( 'post_no_in' ) || '';
			if ( taxName === 'category' && taxTerm && taxTerm !== 'all' ) {
				postNotIn = '';
			}

			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $button.data( 'post_type' ) || '',
				postsPerPage: $button.data( 'posts_per_page' ) || 12,
				currentPage: Number( $button.data( 'current_page' ) ) + 1,
				appendWrapper: $button.data( 'append_wrapper' ) || '',
				context: $button.data( 'context' ) || '',
				colClass: $button.data( 'col_class' ) || '',
				imageWidth: $button.data( 'image_width' ) || '',
				imageHeight: $button.data( 'image_height' ) || '',
				taxName: taxName,
				taxTerm: taxTerm,
				secondTaxName: secondTaxName,
				secondTaxTerm: secondTaxTerm,
				postNotIn: postNotIn,
				county: $resourceLocationFilter.length
					? $resourceLocationFilter.val() || ''
					: '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $button );
		} );
	}

	// Ajax Category filter.
	if ( categoryFilter.length ) {
		categoryFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $statusFilter = $scope.find( '.selectric.status-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 12,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $statusFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $statusFilter.val() || '',
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax Status filter.
	if ( statusFilter.length ) {
		statusFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $categoryFilter = $scope.find( '.selectric.category' );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 12,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $categoryFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $categoryFilter.val() || '',
			};

			sendAjaxRequest( data, $( this ) );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax News Category filter.
	if ( newsCategoryFilter.length ) {
		newsCategoryFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $newsTagFilter = $scope.find( '.selectric.news-tag' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const selectedCategory = $( this ).val() || '';
			const postNotIn =
				selectedCategory && selectedCategory !== 'all'
					? ''
					: $( this ).data( 'post_no_in' ) || '';
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				context: $( this ).data( 'context' ) || '',
				colClass: $( this ).data( 'col_class' ) || '',
				imageWidth: $( this ).data( 'image_width' ) || '',
				imageHeight: $( this ).data( 'image_height' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: selectedCategory,
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $newsTagFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $newsTagFilter.val() || '',
				postNotIn: postNotIn,
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax News Tag filter.
	if ( newsTagFilter.length ) {
		newsTagFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $newsCategoryFilter = $scope.find(
				'.selectric.new-category'
			);
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const selectedCategory = $newsCategoryFilter.val() || '';
			const postNotIn =
				selectedCategory && selectedCategory !== 'all'
					? ''
					: $( this ).data( 'post_no_in' ) || '';
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				context: $( this ).data( 'context' ) || '',
				colClass: $( this ).data( 'col_class' ) || '',
				imageWidth: $( this ).data( 'image_width' ) || '',
				imageHeight: $( this ).data( 'image_height' ) || '',
				taxName: $newsCategoryFilter.data( 'tax_name' ) || '',
				taxTerm: selectedCategory,
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $( this ).data( 'tax_name' ) || '',
				secondTaxTerm: $( this ).val() || '',
				postNotIn: postNotIn,
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax Resource Location
	const resourceLocationFilter = $( '.selectric.county-select' );
	if ( resourceLocationFilter.length ) {
		resourceLocationFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $areaOfFocusFilter = $scope.find(
				'.selectric.area-of-focus'
			);
			const $typeOfOrganizationFilter = $scope.find(
				'.selectric.type-of-organization'
			);
			const $searchFilterInput = $scope.find( '#search-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $areaOfFocusFilter.data( 'tax_name' ) || '',
				taxTerm: $areaOfFocusFilter.val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName:
					$typeOfOrganizationFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $typeOfOrganizationFilter.val() || '',
				county: $( this ).val() || '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );
		} );
	}

	// Ajax Area Of Focus.
	if ( areaOfFocusFilter.length ) {
		areaOfFocusFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $typeOfOrganizationFilter = $scope.find(
				'.selectric.type-of-organization'
			);
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			const $searchFilterInput = $scope.find( '#search-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName:
					$typeOfOrganizationFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $typeOfOrganizationFilter.val() || '',
				county: $resourceLocationFilter.val() || '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );
		} );
	}

	// Ajax Type Of Organization.
	if ( typeOfOrganizationFilter.length ) {
		typeOfOrganizationFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $areaOfFocusFilter = $scope.find(
				'.selectric.area-of-focus'
			);
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			const $searchFilterInput = $scope.find( '#search-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $areaOfFocusFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $areaOfFocusFilter.val() || '',
				county: $resourceLocationFilter.val() || '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );
		} );
	}

	// Ajax Search Filter.
	if (
		( searchFilter.length || resetSearch.length ) &&
		searchFilterInput.length
	) {
		const toggleSearchIcons = function () {
			const hasText = getSearchInputValue( searchFilterInput ).length > 0;
			if ( hasText ) {
				$( resetSearch ).removeClass( 'hidden' );
			} else {
				$( resetSearch ).addClass( 'hidden' );
			}
		};

		const triggerSearch = function ( e ) {
			if ( e ) {
				e.preventDefault();
			}
			if ( searchDebounceTimer ) {
				window.clearTimeout( searchDebounceTimer );
			}

			const rawSearchValue = getSearchInputValue( searchFilterInput );
			const searchValue = normalizeSearchValue( rawSearchValue );
			if ( rawSearchValue.length > 0 && searchValue === '' ) {
				toggleSearchIcons();
				return;
			}

			const $scope = getScope( searchFilterInput );
			const $areaOfFocusFilter = $scope.find(
				'.selectric.area-of-focus'
			);
			const $typeOfOrganizationFilter = $scope.find(
				'.selectric.type-of-organization'
			);
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			const $loadMoreButtons =
				getScopeLoadMoreButtons( searchFilterInput );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( searchFilterInput ).data( 'post_type' ) || '',
				postsPerPage:
					$( searchFilterInput ).data( 'posts_per_page' ) || 9,
				currentPage:
					Number( $( searchFilterInput ).data( 'current_page' ) ) ||
					1,
				appendWrapper:
					$( searchFilterInput ).data( 'append_wrapper' ) || '',
				itemClass: $( searchFilterInput ).data( 'item_class' ) || '',
				taxName: $areaOfFocusFilter.data( 'tax_name' ) || '',
				taxTerm: $areaOfFocusFilter.val() || '',
				secondTaxName:
					$typeOfOrganizationFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $typeOfOrganizationFilter.val() || '',
				county: $resourceLocationFilter.val() || '',
				search: searchValue,
			};

			sendAjaxRequest( data, $( searchFilter ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );

			// Update icons according to the current input value
			toggleSearchIcons();
		};

		const queueSearch = function () {
			const rawSearchValue = getSearchInputValue( searchFilterInput );
			const searchValue = normalizeSearchValue( rawSearchValue );
			if ( rawSearchValue.length > 0 && searchValue === '' ) {
				toggleSearchIcons();
				return;
			}
			if ( searchDebounceTimer ) {
				window.clearTimeout( searchDebounceTimer );
			}
			searchDebounceTimer = window.setTimeout( function () {
				triggerSearch();
			}, SEARCH_DEBOUNCE_DELAY );
		};

		// Initial icon state based on current input value (including URL prefill)
		toggleSearchIcons();

		searchFilter.on( 'click', triggerSearch );
		searchFilterInput.on( 'keydown', function ( e ) {
			if ( e.key === 'Enter' ) {
				triggerSearch( e );
			}
		} );

		// Toggle icons live as user types and debounce search
		searchFilterInput.on( 'input', function () {
			toggleSearchIcons();
			queueSearch();
		} );

		// Reset button clears the field and triggers a new AJAX request
		resetSearch.on( 'click', function ( e ) {
			e.preventDefault();
			$( searchFilterInput ).val( '' );
			toggleSearchIcons();
			triggerSearch( e );
		} );
	}

	/**
	 * Hide the load more button if the current page is the last page.
	 * @param maxPaged
	 * @param currentPage
	 * @param element
	 */
	function hideLoadMoreButton( maxPaged, currentPage, element ) {
		const max = parseInt( maxPaged, 10 );
		const current = parseInt( currentPage, 10 );
		const $element = $( element );

		if ( current >= max ) {
			$element.each( function () {
				this.style.setProperty( 'display', 'none', 'important' );
			} );
		} else {
			$element.each( function () {
				this.style.removeProperty( 'display' );
			} );
			$element.show();
		}
	}

	/**
	 * Update URL parameters without page reload
	 *
	 * @param {Object} params Object containing parameters to add to URL
	 */
	function updateUrlParams( params ) {
		if ( ! params || typeof params !== 'object' ) {
			return;
		}

		const url = new URL( window.location.href );

		url.search = '';
		Object.keys( params ).forEach( ( key ) => {
			if (
				params[ key ] !== '' &&
				params[ key ] !== null &&
				params[ key ] !== undefined
			) {
				url.searchParams.set( key, params[ key ] );
			}
		} );
		window.history.pushState( {}, '', url );
	}

	/**
	 * Send an AJAX request to load more posts.
	 *
	 * @param {Object} data    Ajax request data object containing
	 * @param {Object} element jQuery element that triggered the request
	 */
	function sendAjaxRequest( data, element ) {
		if ( data.length === 0 ) {
			console.error( 'No data to send in AJAX request.' );
			return;
		}

		const $scope = getScope( element );
		const $loadMoreButtons = getScopeLoadMoreButtons( element );

		$loadMoreButtons.prop( 'disabled', true );

		const $appendWrapper = data.appendWrapper
			? $scope.find( data.appendWrapper )
			: $();
		const $targetWrapper = $appendWrapper.length
			? $appendWrapper
			: $( data.appendWrapper );

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			data,
			success( response ) {
				$loadMoreButtons.prop( 'disabled', false );

				if ( response.success ) {
					if ( data.itemClass ) {
						$targetWrapper.find( data.itemClass ).remove();
					}

					$scope.find( '.error-notification' ).remove();
					$targetWrapper.append( response.data.html );
					if ( $loadMoreButtons.length ) {
						$loadMoreButtons.data(
							'current_page',
							data.currentPage
						);
						$loadMoreButtons.data(
							'max_page',
							response.data.maxPage
						);
					} else {
						$( element ).data( 'current_page', data.currentPage );
						$( element ).data( 'max_page', response.data.maxPage );
					}

					hideLoadMoreButton(
						response.data.maxPage,
						data.currentPage,
						$loadMoreButtons.length
							? $loadMoreButtons
							: $( element )
					);
				} else {
					$scope.find( '.error-notification' ).remove();
					if ( data.itemClass ) {
						$targetWrapper.find( data.itemClass ).remove();
					}
					$targetWrapper.append( response.data.html );
					hideLoadMoreButton(
						1,
						1,
						$loadMoreButtons.length
							? $loadMoreButtons
							: $( element )
					);
				}
			},
			error( jqXHR, textStatus, errorThrown ) {
				$loadMoreButtons.prop( 'disabled', false );
				console.error( 'AJAX Error:', textStatus, errorThrown );
			},
		} );
	}
};

export default ( ( $ ) => $( ajaxMorePost ) )( jQuery );
